import { InternalServerErrorBanner } from './InternalServerErrorBanner'
import React, { ErrorInfo } from 'react'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'

export interface IProps {
  children: React.ReactNode
  fallback?: React.ReactElement
  onError?: (error: Error, errorInfo: ErrorInfo) => void
}

const ErrorBoundary = (props: IProps) => {
  const { children, fallback = <InternalServerErrorBanner />, onError } = props

  return (
    <ReactErrorBoundary fallback={fallback} {...(onError ? { onError } : {})}>
      {children}
    </ReactErrorBoundary>
  )
}

export default ErrorBoundary
